module.exports = __webpack_public_path__ + "img/wechat@2x.9fa9c26a.png";